/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wf_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. The analysis runs entirely in your browser; your text is never sent to a server.`)
};

const es_wf_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. El análisis se ejecuta completamente en tu navegador; tu texto nunca se envía a un servidor.`)
};

const de_wf_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Die Analyse läuft vollständig in Ihrem Browser; Ihr Text wird niemals an einen Server gesendet.`)
};

const nl_wf_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. De analyse wordt volledig in uw browser uitgevoerd; uw tekst wordt nooit naar een server verzonden.`)
};

const fr_wf_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. L'analyse s'exécute entièrement dans votre navigateur ; votre texte n'est jamais envoyé à un serveur.`)
};

const it_wf_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. L'analisi viene eseguita interamente nel tuo browser; il tuo testo non viene mai inviato a un server.`)
};

const pt_br2_wf_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A análise é executada inteiramente no seu navegador; seu texto nunca é enviado para um servidor.`)
};

const pt_wf_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A análise é executada inteiramente no seu navegador; o seu texto nunca é enviado para um servidor.`)
};

const ja_wf_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。分析は完全にブラウザで実行されます。テキストはサーバーに送信されることはありません。`)
};

const zh_wf_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会。分析完全在你的浏览器中进行；你的文本永远不会被发送到服务器。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wf_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wf_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wf_faq3_a", locale)
	if (locale === "en") return en_wf_faq3_a(inputs)
	if (locale === "es") return es_wf_faq3_a(inputs)
	if (locale === "de") return de_wf_faq3_a(inputs)
	if (locale === "nl") return nl_wf_faq3_a(inputs)
	if (locale === "fr") return fr_wf_faq3_a(inputs)
	if (locale === "it") return it_wf_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_wf_faq3_a(inputs)
	if (locale === "pt") return pt_wf_faq3_a(inputs)
	if (locale === "ja") return ja_wf_faq3_a(inputs)
	return zh_wf_faq3_a(inputs)
};